exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sj-contract-status p[data-v-71d6aa20]{font-family:Lato;font-style:normal;font-weight:400;font-size:16px;line-height:21px;width:80%}.sj-contract-status h2[data-v-71d6aa20]{font-family:Lato;font-style:normal;font-weight:700;font-size:23px;line-height:16px}.box[data-v-71d6aa20]{background:#fafafa;border:1px solid #e6e6e6;box-sizing:border-box;position:relative;width:100%;margin-left:auto;margin-right:auto}.box[data-v-71d6aa20] h3{margin-top:0;margin-bottom:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71d6aa20","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/molecules/MoleculeContractStatus.vue
// module id = 1291
// module chunks = 0